import { firstEvidenceMonth } from "encamp-shared/src/waste/generatorFindings";
import { GeneratorStatusExceedanceDetailQuery } from "generated-graphql/graphql";
import { useState } from "react";

import { CalculatedStatusHistory } from "./CalculatedStatusHistory";
import { CalculationEvidence } from "./CalculationEvidence";
import { ExceedanceForDrawer } from "./ExceedanceActionDrawer";
import { affectedMonthPeriods } from "./monthlyEvidence";

type Detail = GeneratorStatusExceedanceDetailQuery["generatorStatusExceedanceDetail"];

export function ExceedanceEvidence({
  detail,
  exceedance,
  showStateColumns,
}: {
  detail: Detail;
  exceedance: ExceedanceForDrawer;
  showStateColumns: boolean;
}) {
  const latestAffectedMonth = exceedance.lastPeriodStart ?? exceedance.periodStart;
  const [selectedMonth, setSelectedMonth] = useState(latestAffectedMonth);
  const affected = affectedMonthPeriods({ months: detail.calculatedMonths, ...exceedance });
  const monthOptions = [
    ...new Set([
      latestAffectedMonth,
      ...affected,
      ...detail.calculatedMonths.map((month) => month.periodStart),
    ]),
  ]
    .sort()
    .reverse()
    .map((periodStart) => ({ periodStart, inReview: affected.has(periodStart) }));
  return (
    <>
      <CalculatedStatusHistory
        months={detail.calculatedMonths}
        mismatchPeriodStarts={exceedance.mismatchPeriodStarts}
        mismatchMonths={exceedance.mismatchMonths}
        selectedMonth={selectedMonth}
        periodStart={firstEvidenceMonth(exceedance)}
        lastPeriodStart={latestAffectedMonth}
        facilityState={exceedance.state}
        showStateColumns={showStateColumns}
      />
      <div>
        <CalculationEvidence
          detail={detail}
          inReview={affected.has(selectedMonth)}
          month={selectedMonth}
          monthOptions={monthOptions}
          onSelectMonth={setSelectedMonth}
          latestAffectedMonth={latestAffectedMonth}
          showState={showStateColumns}
          state={exceedance.state}
          tenantId={exceedance.tenantId}
          facilityId={exceedance.facilityId}
        />
      </div>
    </>
  );
}
